import { authenticatedFetch } from "@/lib/auth/authenticatedFetch";
import { ApiResponseError, extractApiError } from "@/lib/errors/apiError";
import { resolveApiError } from "@/lib/errors/resolveApiError";
import { getApiBaseUrl } from "@/lib/utils";
import { type UseQueryOptions, queryOptions } from "@tanstack/react-query";

import { type BucketWithTasks, bucketWithTasksSchema } from "@workspace/schemas/zod";

type BucketsForUserAndDayResponse = BucketWithTasks[];

export const bucketsForUserAndDayQueryOptions = (
  userId: string,
  day?: string,
  options: Omit<UseQueryOptions<BucketsForUserAndDayResponse>, "queryKey" | "queryFn"> = {},
) =>
  queryOptions({
    queryKey: ["buckets", "user", userId, day ?? "all"],
    queryFn: async ({ signal }) => {
      const baseUrl = getApiBaseUrl();
      const url = day ? `${baseUrl}/buckets/user?userId=${userId}&day=${day}` : `${baseUrl}/buckets/user?userId=${userId}`;
      const response = await authenticatedFetch(url, { signal });

      if (!response.ok) {
        const apiError = await extractApiError(response);
        const userMessage = resolveApiError(apiError.error_code, "Buckets konnten nicht geladen werden");
        throw new ApiResponseError(response.status, apiError.error_code, apiError.details, userMessage);
      }

      // Type assertion needed because z.infer doesn't properly type date fields from callback overrides
      return bucketWithTasksSchema.array().parse(await response.json()) as unknown as BucketsForUserAndDayResponse;
    },
    ...options,
  });
